var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ButtonSizes } from "./types";
import { BaseButtonStyled, BaseButtonAnchorStyled } from "./baseButton.styled";
import LoadingSpinner from "./LoadingSpinner";
import IconWrapper from "./IconWrapper";
var BaseButton = function (_a) {
    var url = _a.url, children = _a.children, onClick = _a.onClick, className = _a.className, disabled = _a.disabled, isLoading = _a.isLoading, loadingText = _a.loadingText, _b = _a.size, size = _b === void 0 ? ButtonSizes.large : _b, type = _a.type, role = _a.role, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, fullWidth = _a.fullWidth, svgMargin = _a.svgMargin, props = __rest(_a, ["url", "children", "onClick", "className", "disabled", "isLoading", "loadingText", "size", "type", "role", "leftIcon", "rightIcon", "fullWidth", "svgMargin"]);
    if (url) {
        var isUrlExternal = /^https?/.test(url);
        if (isUrlExternal) {
            return (React.createElement(BaseButtonAnchorStyled, { as: "a", className: className, size: size, role: role, type: type, href: url, target: "_blank", rel: "noopener noreferrer", fullWidth: fullWidth, svgMargin: svgMargin },
                React.createElement(IconWrapper, { size: size, leftIcon: leftIcon, rightIcon: rightIcon }, children)));
        }
        return (React.createElement(BaseButtonAnchorStyled, { as: "a", className: className, size: size, role: role, type: type, href: url, fullWidth: fullWidth, svgMargin: svgMargin },
            React.createElement(IconWrapper, { size: size, leftIcon: leftIcon, rightIcon: rightIcon }, children)));
    }
    return (React.createElement(BaseButtonStyled, __assign({ className: className, size: size, role: role, type: type, disabled: disabled, onClick: onClick, fullWidth: fullWidth, svgMargin: svgMargin }, props), isLoading ? (React.createElement(React.Fragment, null,
        React.createElement(LoadingSpinner, { size: size, role: role }),
        loadingText || "Loading...")) : (React.createElement(IconWrapper, { size: size, leftIcon: leftIcon, rightIcon: rightIcon }, children))));
};
export default BaseButton;
